import axios from 'axios'

//const API_BASE_URL = 'http://36.50.84.162:8000/api'
const API_BASE_URL = 'https://txt.516768.xyz/api'

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器：添加token
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器：处理错误
apiClient.interceptors.response.use(
  response => response.data,
  error => {
    if (error.response?.status === 401) {
      // token过期，清除本地存储并跳转到登录页
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// API方法
export default {
  // 认证
  login(username, password) {
    return apiClient.post('/login', { username, password })
  },
  logout() {
    return apiClient.post('/logout')
  },

  // 用户管理
  getUsers(params) {
    return apiClient.get('/users', { params })
  },
  createUser(userData) {
    return apiClient.post('/users', userData)
  },
  updateUser(userId, userData) {
    return apiClient.put(`/users/${userId}`, userData)
  },
  deleteUser(userId) {
    return apiClient.delete(`/users/${userId}`)
  },

  // 书籍管理
  getBooks(params) {
    return apiClient.get('/books', { params })
  },
  getBook(bookId) {
    return apiClient.get(`/books/${bookId}`)
  },
  createBook(formData) {
    return apiClient.post('/books', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  updateBook(bookId, bookData) {
    return apiClient.put(`/books/${bookId}`, bookData)
  },
  deleteBook(bookId) {
    return apiClient.delete(`/books/${bookId}`)
  },
  getBookContent(bookId, params) {
    return apiClient.get(`/books/${bookId}/content`, { params })
  },

  // 阅读进度
  getReadingProgress(bookId) {
    return apiClient.get(`/reading-progress/${bookId}`)
  },
  updateReadingProgress(bookId, progressData) {
    return apiClient.put(`/reading-progress/${bookId}`, progressData)
  },

  // 书签管理
  getBookmarks(params) {
    return apiClient.get('/bookmarks', { params })
  },
  getBookBookmarks(bookId) {
    return apiClient.get(`/bookmarks/book/${bookId}`)
  },
  createBookmark(bookmarkData) {
    return apiClient.post('/bookmarks', bookmarkData)
  },
  updateBookmark(bookmarkId, bookmarkData) {
    return apiClient.put(`/bookmarks/${bookmarkId}`, bookmarkData)
  },
  deleteBookmark(bookmarkId) {
    return apiClient.delete(`/bookmarks/${bookmarkId}`)
  }
}
